"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
var _image = _interopRequireDefault(require("./image"));
var _entityLite = require("./entity-lite");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var createLinkedItem = function createLinkedItem(_ref) {
  var sys = _ref.sys,
    fields = _ref.fields;
  return _objectSpread(_objectSpread({}, (0, _entityLite.createEntityLite)({
    sys: sys,
    fields: fields
  })), {}, {
    image: (0, _utils.getProp)(fields, 'image') ? (0, _image["default"])(fields.image) : null,
    title: (0, _utils.getProp)(fields, 'title') || (0, _utils.getProp)(fields, 'name'),
    description: (0, _utils.getProp)(fields, 'shortDescription') || (0, _utils.getProp)(fields, 'jobTitle')
  });
};
var getContent = function getContent(document) {
  if ((document === null || document === void 0 ? void 0 : document.nodeType) === 'document') {
    return (0, _processRichText["default"])({
      document: document,
      factories: _standard["default"]
    });
  }
  return document;
};
var createContraceptionComparisonOption = function createContraceptionComparisonOption(_ref2) {
  var sys = _ref2.sys,
    fields = _ref2.fields;
  var description = (0, _utils.getProp)(fields, 'description');
  var effectivenessMoreInfo = (0, _utils.getProp)(fields, 'effectivenessMoreInfo');
  var lengthOfUseMoreInfo = (0, _utils.getProp)(fields, 'lengthOfUseMoreInfo');
  var periodsAndBleeding = (0, _utils.getProp)(fields, 'periodsAndBleeding');
  var possibleSideEffects = (0, _utils.getProp)(fields, 'possibleSideEffects');
  var hormones = (0, _utils.getProp)(fields, 'hormones');
  var impactOnFertility = (0, _utils.getProp)(fields, 'impactOnFertility');
  var healthRisks = (0, _utils.getProp)(fields, 'healthRisks');
  var healthBenefits = (0, _utils.getProp)(fields, 'healthBenefits');
  var aGoodOptionIf = (0, _utils.getProp)(fields, 'aGoodOptionIf');
  var weight = (0, _utils.getProp)(fields, 'weight');
  var mentalHealth = (0, _utils.getProp)(fields, 'mentalHealth');
  var discreetness = (0, _utils.getProp)(fields, 'discreetness');
  var whatDoINeedToRemember = (0, _utils.getProp)(fields, 'whatDoINeedToRemember');
  var learnMoreLinkItem = fields.learnMoreLink ? createLinkedItem(fields.learnMoreLink) : null;
  var whereToGetLinkItem = fields.whereToGetLink ? createLinkedItem(fields.whereToGetLink) : null;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    name: (0, _utils.getProp)(fields, 'name'),
    image: (0, _utils.getProp)(fields, 'image') ? (0, _image["default"])(fields.image) : null,
    description: getContent(description),
    effectiveness: (0, _utils.getProp)(fields, 'effectiveness'),
    effectivenessMoreInfo: getContent(effectivenessMoreInfo),
    lengthOfUse: (0, _utils.getProp)(fields, 'lengthOfUse'),
    lengthOfUseMoreInfo: getContent(lengthOfUseMoreInfo),
    periodsAndBleeding: getContent(periodsAndBleeding),
    possibleSideEffects: getContent(possibleSideEffects),
    hormones: getContent(hormones),
    impactOnFertility: getContent(impactOnFertility),
    healthRisks: getContent(healthRisks),
    healthBenefits: getContent(healthBenefits),
    aGoodOptionIf: getContent(aGoodOptionIf),
    weight: getContent(weight),
    mentalHealth: getContent(mentalHealth),
    discreetness: getContent(discreetness),
    whatDoINeedToRemember: getContent(whatDoINeedToRemember),
    stiProtection: (0, _utils.getProp)(fields, 'stiProtection'),
    learnMoreLink: (0, _utils.getProp)(learnMoreLinkItem, 'url'),
    whereToGetLink: (0, _utils.getProp)(whereToGetLinkItem, 'url'),
    learnMoreButtonText: (0, _utils.getProp)(fields, 'learnMoreButtonText'),
    whereToGetButtonText: (0, _utils.getProp)(fields, 'whereToGetButtonText')
  };
};
var _default = createContraceptionComparisonOption;
exports["default"] = _default;